import { ICellRendererAngularComp } from 'ag-grid-angular';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';

import { ResourcesService } from '@mitsubishi/core';
import { PerformanceAlertsIconComponent } from '@mitsubishi/shared/components';
import { PerformanceMessage, StudyUnitPerformanceRow } from '@mitsubishi/shared/data-access';
import { ApmIcons } from '@mitsubishi/ui/icons';
import { ICellRendererParamsAction, ITableWithActionsComponent } from '@mitsubishi/ui/table';

import { isNil } from '@angular-ru/cdk/utils';

@Component({
  selector: 'apm-table-message-cell',
  templateUrl: './table-performance-alerts-cell.component.html',
  styleUrls: ['./table-performance-alerts-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, PerformanceAlertsIconComponent],
})
export class TablePerformanceAlertsCellComponent implements ICellRendererAngularComp {
  private cdr = inject(ChangeDetectorRef);
  private resourcesService = inject(ResourcesService);

  params!: ICellRendererParamsAction;
  componentParent!: ITableWithActionsComponent;
  icon?: ApmIcons;
  value: any;
  workingConditionName = '-';
  performanceMessages: PerformanceMessage[] = [];
  hasConfigurationErrorAlerts = false;
  additionalErrorMessagesCount = 0;

  agInit(params: ICellRendererParamsAction) {
    this.setData(params);
  }

  refresh(params: ICellRendererParamsAction): boolean {
    this.setData(params);

    return true;
  }

  showMessagesDetails(messages: PerformanceMessage[]): void {
    this.componentParent.performAction({
      action: this.params.values.action,
      data: {
        messages: messages.map(message => {
          return message.parametersExtended
            ? {
                ...message,
                parameters: message.parametersExtended.map(parameterExtended => {
                  if (parameterExtended.dataType === 3) {
                    return this.resourcesService.getTextResource(parameterExtended.resourceId);
                  } else {
                    return parameterExtended.value;
                  }
                }),
              }
            : message;
        }),

        unitName: this.params.data.unitName,
        externalUnitName: this.params.data.externalUnitName,
        unitConfigErrorCode: this.params.data.unitConfigErrorCode,
        externalUnitConfigErrorCode: this.params.data.externalUnitConfigErrorCode,
        accessoriesErrorConfigCodes: this.params.data.accessoriesErrorConfigCodes,

        title: this.workingConditionName,
      },
    });
  }

  private setData(params: ICellRendererParamsAction) {
    this.params = params;
    const data = params.data as StudyUnitPerformanceRow;
    this.value = params.value;
    this.componentParent = this.params.context.componentParent;
    this.performanceMessages = data.performance.messages || [];
    this.workingConditionName = data.workingConditionName;
    const accessoriesErrorConfigCodes = Object.keys(data.accessoriesErrorConfigCodes ?? {});
    this.hasConfigurationErrorAlerts =
      !isNil(data.unitConfigErrorCode) ||
      !isNil(data.externalUnitConfigErrorCode) ||
      accessoriesErrorConfigCodes.length > 0;
    this.additionalErrorMessagesCount = accessoriesErrorConfigCodes.length;
    if (!isNil(data.unitConfigErrorCode)) {
      this.additionalErrorMessagesCount++;
    }
    if (!isNil(data.externalUnitConfigErrorCode)) {
      this.additionalErrorMessagesCount++;
    }

    this.cdr.detectChanges();
  }
}
